module.exports = "/static/media/phone-icon-white.18df5030.png";